import React from 'react'

import Navigation from '../Navigation/Navigation'

import classes from './Layout.module.scss'

export default function Layout(props)  {
	return (
		<React.Fragment>
			<Navigation
				{...props}
			/>
			<section
				className={classes.Layout__container}
			>
				{props.children}
			</section>
		</React.Fragment>
	)
}